var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAcresco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1041.02 1026.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.25;}.cls-2{fill:#7c233c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M786.84,144a383.81,383.81,0,0,0-103.92-39,21.64,21.64,0,0,0,3,2.34c69.3,37.87,120.16,93.84,154.47,163.94,72.06,147.2,81.33,300.2,34.36,456.31-21.58,71.72-61.58,133.32-116.49,184.6-79.2,74-173.93,93.29-277.8,75.59C334.62,962.9,235,878.32,177.35,744.38c-44.71-103.89-49.8-212.4-25-322.1C176.6,315,231.78,225.7,319.7,159.88,385,111,457.39,72.77,530.66,36.75c25.23-12.4,51.2-23.11,76.5-36.75L142.73,50c38,29.33,75.93,58.63,114.79,88.62-5.21,3-9,5.1-12.72,7.36C68.32,253.77-17.36,408.85,2.93,617,13,720.7,60.33,807.78,138.19,876.08,280,1000.51,445.79,1048,631.88,1016.93c128.61-21.5,233.46-85.81,312.52-190,52-68.51,82.05-146.14,92.62-231.62,9.2-74.44,3.34-146.95-25.93-216.45C966.21,272.26,886.24,198.6,786.84,144Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M353.43,187.89c-13.45,9.57-13.45,9.57-1.8,21.53,23.73,23.21,46.54,47.39,69.28,71.6,6.44,6.86,9,6.82,13.68-1.9,28-52.7,56.65-105.08,85.06-157.58Q537.86,87.9,556,54.2c-22.69,13.7-45.62,27-68.14,41C441.53,123.91,396.27,154.1,353.43,187.89Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAcresco);
export default __webpack_public_path__ + "static/media/logo_acresco.e4b831f158e549836633bcf3fd3a09a2.svg";
export { ForwardRef as ReactComponent };